import { Navigate } from 'react-router-dom';
import { useAuth } from 'hooks/auth';
import type { ProtectedRouteProps } from './types';

export const ProtectedRoute = ({
  allowedRoles,
  blockedRoles,
  redirectTo = '/',
  replace = true,
  children,
}: ProtectedRouteProps) => {
  const { profile } = useAuth();
  const userRole = profile?.type;

  if (!userRole) {
    return <Navigate to="/login" replace={replace} />;
  }

  if (blockedRoles && blockedRoles.includes(userRole as any)) {
    return <Navigate to={redirectTo} replace={replace} />;
  }

  if (allowedRoles && !allowedRoles.includes(userRole as any)) {
    return <Navigate to={redirectTo} replace={replace} />;
  }

  return <>{children}</>;
};